<template>
  <div class='have-zoom'>
    <h1>汇说活动管理列表</h1>
    <el-table :data='tableShow'>
      <el-table-column prop='id' label='活动ID'/>
      <el-table-column prop='stage' label='活动期数'/>
      <el-table-column prop='type' label='活动类型' />
      <el-table-column prop='title' label='活动标题' />
      <el-table-column prop='city' label='举办城市' />
      <el-table-column prop='address' label='举办地址' />
      <el-table-column prop='startTime' label='开始时间' />
      <el-table-column prop='expireTime' label='结束时间' />
      <el-table-column prop='limit' label='可报名人数' />
      <el-table-column fixed='right' label='开放状态'>
        <template slot-scope='scope'>
          <div :class="['switch-b',scope.row.status===1?'active-switch-b':'']" @click='changeStatus(scope.row)'>
            <div :class="['switch-b-div',scope.row.status===1?'active-div':'']"></div>
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed='right' label='相关操作' min-width='200'>
        <template slot-scope='scope'>
          <el-button @click="editrow(scope.row.id)" type="text" size="small">编辑会议</el-button>
          <el-button @click='agendaAM(scope.row.id)' type="text" size="small">上午议程</el-button>
          <el-button @click='inforow(scope.row.id)' type="text" size="small">通知参会</el-button>
          <el-button @click='allUser(scope.row.type,scope.row.id)' type="text" size="small">已申请报名用户</el-button>
          <span v-if="new Date(scope.row.startTime).getTime()<nowDate" class="over-time">已过期</span>
          <span v-else-if="new Date(scope.row.startTime).getTime()-86400000<nowDate" class="close-time">24小时内</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="normal-pagination">
      <el-pagination layout="prev, pager, next" :page-size="8" :total="total" style="float:right" @current-change='changePage'>
      </el-pagination>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      tableShow: [],
      nowDate: new Date()
      
    };
  },
  methods: {
    changeStatus(item) {
      let hold = !item.status + 0;
      let form = {
        id: item.id,
        status: hold
      };
      this.$http.freetalks_status({ ...form }).then(res => {
        if (res.data.statusCode === 200) {
          item.status = hold;
        } else {
          this.$message.error("修改状态未成功");
        }
      });
    },
    changePage(id) {
      const start = (id - 1) * 8;
      const end = start + 8;
      this.tableShow = this.tableData.slice(start, end);
    },
    editrow(id) {
      this.$router.push(`/freetalks/post/${id}`);
    },
    inforow(id) {
      this.$router.push(`/sms/freetalks/${id}`);
    },
    initData() {
      this.$http.freetalks_list().then(res => {
        if (res.data.statusCode === 200) {
          this.tableData = res.data.result.reverse();
          this.changePage(1);
        } else {
          this.$message.error("数据请求未成功");
        }
      });
    },
    allUser(type, id) {
      this.$router.push(`/users/${type}/${id}`);
    },
    agendaAM(id) {
      let type = `freetalks`;
      this.$router.push(`/agenda/am/post/${type}/${id}`);
    },
    agendaPM(id) {
      let type = `hkstocks`;
      this.$router.push(`/agenda/pm/post/${type}/${id}`);
    }
  },
  computed: {
    total() {
      return this.tableData.length;
    }
  },
  mounted() {
    this.initData();
  }
};
</script>

<style>
.el-table__fixed,
.el-table__fixed-right {
  overflow: hidden;
}
.switch-b {
  margin-left: 20px;
  width: 40px;
  height: 22px;
  border-radius: 15px;
  background-color: rgb(218, 0, 0) !important;
  transition: background-color 400ms;
  cursor: pointer;
  position: relative;
}
.active-switch-b {
  background-color: rgb(0, 202, 216) !important;
}
.switch-b-div {
  position: absolute;
  top: 50%;
  margin: 0 2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: #fff;
  transition: transform 400ms;
  transform: translateX(0%) translateY(-50%);
}
.active-div {
  transform: translateX(100%) translateY(-50%);
}
.over-time {
  color: red;
  margin-left: 5px;
}
.close-time {
  margin-left: 5px;
  color:lightseagreen;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/freetalks.vue